import { render } from "./Reviews.vue?vue&type=template&id=29f9e874"
import script from "./Reviews.vue?vue&type=script&lang=js"
export * from "./Reviews.vue?vue&type=script&lang=js"

import "./Reviews.vue?vue&type=style&index=0&id=29f9e874&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__